import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import {
  Box,
  Paper,
  TextField,
  MenuItem,
  Button,
  Typography,
  Alert,
  CircularProgress,
} from "@mui/material";
import { FileUploader } from "./UploadFiles";
import { initiatePayment } from "./PaymentComponent"; // Import the payment function
import axios from "axios";
import { getToken } from "auth/authenticate";
import useDeedToast from "hook/useDeedToast";
import { useNavigate } from "react-router-dom";
import { FilePresentOutlined } from "@mui/icons-material";
import { authHeader } from "auth/authHeader";

const APPOINTMENT_PURPOSES = {
  REPORT_READING: "Report Reading",
  CONSULTING: "Consultation",
};

const APPOINTMENT_TYPES = {
  ONLINE: "Online Video Chat",
  PHYSICAL: "Physical",
};

const AptExtFillTheData = ({
  patientData,
  doctorData,
  appointmentId,
  appointmentData,
  validatedPayment,
}) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { deedToast } = useDeedToast();
  const [userData, setUserData] = useState(null);
  const [paymentData, setPaymentData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorShow, setErrorShow] = useState(false);
  const [txnStatus, setTxnStatus] = useState(null);
  const navigate = useNavigate();
  const [pdfUrl, setPdfUrl] = useState("");
  const [aptData, setAptData] = useState(null);

  useEffect(() => {
    fetchData();
    loadDetails();
  }, [appointmentData, appointmentId]);

  useEffect(() => {
    setPdfUrl(aptData?.prescriptionBase64PdfString);
  }, [aptData]);

  // useEffect(() => {
  //   skipPaymentProcess();
  // }, [paymentData]);

  const fetchData = async () => {

    try {
      if (appointmentData?.patientId) {
        // check payment type data
        // await checkVerifiedPaymentType();
        await checkPaymentStatus();
        // Fetch user patient data
        await userPatientData();
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // You can set an error state to handle UI feedback here
      setErrorShow(true);
    }
  };

  const loadDetails = () => {
    // setLoading(true);
    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}appointment/${appointmentId}`, {
        headers: authHeader(),
      })
      .then(function (response) {
        setAptData(response.data?.data?.[0]);
      })
      .catch((error) => {
        // JSON.stringify(error);
        // console.log(error);
        // setError("Invalid Credentials");
      })
      .finally(() => {
        // setLoading(false);
      });
  };

  const userPatientData = async () => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}user/patient/${appointmentData.patientId}`,
        {
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );
      // console.log("user data response: ", JSON.stringify(resp?.data?.data));
      setUserData(resp?.data?.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const getAttachmentNameFromTitle = (title) => {
    let arr = title.split(" ");
    if (arr.length > 2) return `${arr[0]} ${arr[1]}`;
    else return arr[0];
  };

  const getAttachmentNameFromUrl = (url) => {
    let last = url.substring(url.lastIndexOf("/") + 1, url.length);
    let splitted = last.split("?AWSAccessKeyId=");
    return splitted[0];
  };

  // check if appointment has paid successfull. if success, neglect the payment process.
  const checkPaymentStatus = async () => {
    if (!appointmentId) {
      // console.log("No appointment ID provided.");
      return;
    }
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}payment/payment-status/${appointmentId}`,
        {
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );
      // console.log(
      //   "appointment payment data response: ",
      //   JSON.stringify(res?.data.data[0])
      // );
      setPaymentData(res?.data.data[0]);
      const status = res?.data?.data[0]?.txnStatus;
      setTxnStatus(status === "SUCCESS");
    } catch (error) {
      // console.log(error);
    }
  };

  const handleSuccess = async () => {
    setLoading(true);
    try {
      // Poll backend to verify payment status
      const statusResponse = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}payment/payment-status/${appointmentId}`,
        {
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );

      if (statusResponse.data.status === "SUCCESS") {
        navigate("/apt-external/join-consultation/", {
          state: {
            secretData: { appointmentData, userData },
          },
        });
      } else {
        setLoading(true);
      }
    } catch (error) {
      alert("Error verifying payment: " + error.message);
    }
    setLoading(false);
  };

  const handlePaymentProcess = async (values) => {
    const formData = new FormData();

    // Append files to FormData
    if (selectedFiles && selectedFiles.length > 0) {
      selectedFiles.forEach((file) => {
        formData.append("files", file); // `files` is the expected key on the backend
      });
    }

    // Append other fields to FormData
    formData.append(
      "appointmentType",
      appointmentData?.appointmentType || values.appointmentType || ""
    );
    formData.append(
      "purpose",
      appointmentData?.purpose || values.purpose || ""
    );
    formData.append("medicalDetails", values.medicalDetails || "");
    formData.append("message", values.message || "");
    formData.append(
      "amount",
      doctorData?.displayingFee || paymentData.amount || 0
    );
    formData.append("paymentId", paymentData?.id.toString() || "test_id");
    formData.append("parentId", appointmentData?.patientId);

    try {
      await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}appointment/patient/ext-appointment/${appointmentId}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
      deedToast("Appointment Updated Successfully");

      if (validatedPayment === "OFFLINE-FE" || txnStatus === true) {
        navigate("/apt-external/join-consultation/", {
          state: {
            secretData: { appointmentData, userData },
          },
        });
      } else if (validatedPayment === "ONLINE-PH" && txnStatus === false) {
        initiatePayment({
          patientData,
          userData,
          doctorData,
          appointmentId,
          onSuccess: () => handleSuccess(),
          //   {
          //   navigate("/apt-external/join-consultation/", {
          //     state: {
          //       secretData: { appointmentData, userData },
          //     },
          //   })
          // },
          onError: (msg) => {
            alert("Payment Error: " + msg);
          },
        });
      }
    } catch (error) {
      console.error("Error updating appointment: ", error);
    }
  };

  const formik = useFormik({
    initialValues: {
      purpose: appointmentData?.purpose || "",
      appointmentType: appointmentData?.appointmentType || "",
      medicalDetails: appointmentData?.medicalDetails || "",
      message: appointmentData?.message || "",
      attachments: appointmentData?.attachments || [],
    },
    validate: (values) => {
      const errors = {};
      if (!values.purpose) errors.purpose = "Purpose is required";
      if (!values.appointmentType)
        errors.appointmentType = "Appointment type is required";
      return errors;
    },

    onSubmit: async (values) => {
      setLoading(true);

      if (validatedPayment === "OFFLINE-FE") {
        handlePaymentProcess(values);
      } else if (validatedPayment === "ONLINE-PH") {
        if (txnStatus === true) {
          handlePaymentProcess(values);
        } else {
          handlePaymentProcess(values);
        }
      }
      setLoading(false);
    },
  });

  return (
    <Box m={2} p={3} component={Paper} elevation={3}>
      {appointmentData?.status == "COMPLETED" ? (
        <>
          <h1 style={{ margin: "0px 0px 15px 0px", padding: 0 }}>
            Appointment Details
          </h1>
          <Typography variant="body2" gutterBottom>
            This appointment has completed. View appointment details through
            consultation reports.
          </Typography>
        </>
      ) : (
        <Typography variant="h4" gutterBottom>
          Fill Appointment Details
        </Typography>
      )}
      {loading ? <CircularProgress /> : " "}
      {errorShow ? (
        <Alert variant="filled" severity="error">
          Something is wrong with Appointment Data. Please contact support
        </Alert>
      ) : (
        ""
      )}

      <form onSubmit={formik.handleSubmit}>
        <TextField
          sx={{ marginTop: "1rem" }}
          select
          fullWidth
          id="purpose"
          name="purpose"
          value={formik.values.purpose}
          onChange={formik.handleChange}
          disabled={appointmentData?.status == "COMPLETED"}
          error={formik.touched.purpose && Boolean(formik.errors.purpose)}
          helperText={formik.touched.purpose && formik.errors.purpose}
        >
          {Object.entries(APPOINTMENT_PURPOSES).map(([key, label]) => (
            <MenuItem key={key} value={key}>
              {label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          fullWidth
          id="type"
          name="type"
          value={formik.values.appointmentType}
          onChange={formik.handleChange}
          disabled={appointmentData?.status == "COMPLETED"}
          error={
            formik.touched.appointmentType &&
            Boolean(formik.errors.appointmentType)
          }
          helperText={
            formik.touched.appointmentType && formik.errors.appointmentType
          }
          sx={{ marginTop: "1rem" }}
        >
          {Object.entries(APPOINTMENT_TYPES).map(([key, label]) => (
            <MenuItem key={key} value={key}>
              {label}
            </MenuItem>
          ))}
        </TextField>

        <div style={{ marginTop: "1rem" }}>
          <TextField
            fullWidth
            id="medicalDetails"
            name="medicalDetails"
            value={formik.values.medicalDetails}
            onChange={formik.handleChange}
            placeholder="Medical Details"
            disabled={appointmentData?.status == "COMPLETED"}
          />

          <TextField
            sx={{ marginTop: "1rem" }}
            fullWidth
            id="message"
            name="message"
            value={formik.values.message}
            onChange={formik.handleChange}
            placeholder="Message"
            disabled={appointmentData?.status == "COMPLETED"}
          />
        </div>

        {appointmentData?.status == "COMPLETED" ? (
          <Button
            sx={{
              marginTop: "1rem",
              ":hover": { backgroundColor: "#1a73e8", color: "#ffffff" },
            }}
            type="submit"
            variant="outlined"
            color="primary"
          >
            View Consultation Reports
          </Button>
        ) : (
          <>
            {" "}
            <FileUploader
              selectedFiles={selectedFiles}
              setSelectedFiles={setSelectedFiles}
              formik={formik}
            />

          
            <Button type="submit" variant="contained" color="primary">
              Update Appointment
            </Button>
          </>
        )}

        {/* Payment Component */}
        {/* <PaymentComponent
        patientData={patientData}
        doctorData={doctorData}
        appointmentId={appointmentId}
        onError={(msg) => alert("Payment error: " + msg)}
        onSuccess={() => alert("Payment started successfully!")}
      /> */}
      </form>
      <div style={{ marginBottom: "20px" , marginTop:'40px'}}>

              {aptData?.attachments?.length > 0 && (
                <>
                      <h5>Previously Attached Files</h5>

                  {aptData.attachments.map((e, i) => {
                    return (
                      <a
                        className="attachment-file"
                        key={"att" + i}
                        style={{ marginBottom: "5px" }}
                        href={e}
                      >
                        <FilePresentOutlined fontSize="small" />

                        <div style={{ overflow: "hidden" }}>
                          <p>{getAttachmentNameFromUrl(e)}</p>
                        </div>
                      </a>
                    );
                  })}
                  {aptData.attachmentPdfString.map((attachment) => {
                    return (
                      <a
                        className="attachment-file"
                        key={attachment.filename}
                        style={{ marginBottom: "5px" }}
                        href={attachment.url}
                      >
                        <FilePresentOutlined fontSize="small" />
                        <p>{getAttachmentNameFromTitle(attachment.title)}</p>
                      </a>
                    );
                  })}
                </>
              )}
            </div>
    </Box>
  );
};

export default AptExtFillTheData;
